<button
  mat-icon-button
  [color]="primary ? 'primary' : (accent ? 'accent' : null)"
  [matMenuTriggerFor]="actionsMenu"
>
  <mat-icon>more_vert</mat-icon>
</button>

